'use strict';
var novicell = novicell || {};

novicell.openChatAutomatically = novicell.openChatAutomatically || function () {

    //INFORMATION
    //Someone created a bunch of JS regarding the chat in a plugin, which can be edited in the WP backend.
    //The following works with that code, to either show or hide the chat on page load, when the chat is "open"
    //We set a cookie, so if the chat is minimized, we wont show that when browsing the site further.


    function init() {
        
        //If theres no cookie set, set it to true now, which means the chat will be open
        if (!getCookie('open-chat')){
            setCookie('open-chat', 'true', 1);
        }

        var chat_client = document.querySelector('.cm-Chat-client');

        if ( chat_client ) {
            //If the chat is closed, set the cookie to false, so we wont open the chat
            document.querySelector('.cm-Chat-header-menu-left').addEventListener('click', function(){
                setCookie('open-chat', 'false', 1);
            });

            //Open chat, set cookie to open
            document.querySelector('button.open-chat').addEventListener('click', function(){
                setCookie('open-chat', 'true', 1);
            });
        }
    }



    return {
        init : init
    };


    //Default cookie functions
    function setCookie(name, value, days) {
        var d = new Date;
        d.setTime(d.getTime() + 24*60*60*1000*days);
        document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
    }

    function getCookie(name) {
        var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
        return v ? v[2] : null;
    }

    function deleteCookie(name) { setCookie(name, '', -1); }

}();
